export const PreviousWorksData: {documentationUrl?: string, hasDocumentation: boolean, hasSource: boolean, hasPreview:boolean, sourceLink?: string, name: string, link: string, description: string, tags: string[], img: string}[] = [
    {
        name: 'Angular ToDo App',
        link: 'https://omarwebdev-todo-angular.netlify.app/',
        description: 'Todo app to manage your tasks',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/prev_works/AngularTodoApp_8p-clLSf7.webp?ik-sdk-version=javascript-1.4.3&updatedAt=1647622622503',
        tags: ['HTML', 'CSS','JS','Angular','Angular Material','Firebase','CRUD'],
        hasPreview: true,
        hasSource: false,
        hasDocumentation: false,
    },
    {
        name: 'Bootstrap Portfolio Template',
        link: 'https://omarwebdev.github.io/portfolio-template/',
        description: 'Simple bootstrap portfolio',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/prev_works/bootstrap-portfolio-template_Z6rmxh7YS.png?ik-sdk-version=javascript-1.4.3&updatedAt=1647622622518',
        tags: ['HTML', 'CSS', 'JS', 'jQuery', 'Template'],
        hasPreview: true,
        hasSource: true,
        sourceLink: 'https://github.com/OmarWebDev/portfolio-template/',
        hasDocumentation: false,
    },
    {
        name: 'Vastate JS',
        link: '',
        description: 'A javascript library that can be used to print javascript variables to html easily',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/prev_works/vastateLogo_-sR7dE5q5.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1648420864822',
        tags: ['JS', 'TS', 'JS-Library'],
        hasPreview: false,
        hasSource: true,
        sourceLink: 'https://github.com/OmarWebDev/vastate-js',
        hasDocumentation: true,
        documentationUrl: 'https://github.com/OmarWebDev/vastate-js'
    },
]